module.exports = __webpack_public_path__ + "img/32_9.c9a36eb5.png";